export default {"src":"__ASTRO_ASSET_IMAGE__Dxg$UnOv__","width":256,"height":256,"format":"webp"}